import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class StickyNavigationConverter extends CmsConverterService<StickyNavigationData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const STICKY_NAVIGATION_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, StickyNavigationData>>('StickyNavigationConverter')

export type StickyNavigationData = ConvertedComponentData
